module.exports = __webpack_public_path__ + "e0e76d8154ccd2aa98cff87e879fbca2.svg";